import React, { useState } from 'react';
import classNames from 'classnames';

import Loader from 'components/Loader';
import useStyles from './styles';

interface IProps {
  url: string;
  title?: string;
  fullScreen?: boolean;
}

const RewstIframe: React.FC<IProps> = ({ url, title = 'Rewest Form', fullScreen = false }) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);

  const handleIframeLoad = (): void => {
    setIsLoading(false);
  };

  if (!url) {
    return <div>Rewest form URL not provided</div>;
  }

  return (
    <div className={classNames(classes.container, fullScreen && classes.containerFullScreen)}>
      {isLoading && (
        <div
          className={classNames(
            classes.loaderContainer,
            fullScreen && classes.loaderContainerFullScreen,
          )}
        >
          <Loader />
        </div>
      )}
      <iframe
        src={url}
        className={classNames(classes.iframe, fullScreen && classes.iframeFullScreen)}
        title={title}
        sandbox="allow-scripts allow-forms allow-popups allow-top-navigation allow-same-origin"
        onLoad={handleIframeLoad}
      />
    </div>
  );
};

export default RewstIframe;
